$(document).ready(function() {

    var currentUrl = window.location.href;

    // Check if the current URL contains the query parameter "?cart-drawer=true"
    if (currentUrl.indexOf('?cart-drawer=true') !== -1) {
    $(".cart-icon-trigger").attr("aria-expanded","true")
    }
  });

  $(document).on("click"," .block-swatch",function() {
     setTimeout(function() {
  var data = $(".get-data-custom").html();
    // console.log(data+"fff")
    $(".custom-data-trigger").html(data);
       }, 200);
  });

     $(document).on("click",".wrap-variant-input",function() {
      
      var data = $(this).attr("data");
        var data2 = $(this).attr("data2");
       var data3 = $(this).attr("data3");
        var price = $(this).attr("price");
       var stock = $(this).attr("stock");
       var atc = $(this).attr("atc");
         var avadata = $(this).attr("available");
    var solddata = $(this).attr("sold-out");
      
        var disableproduct = $(this).attr("product-id");
      
        var dotsid = $(this).attr("dots-id");
       
    

       if (stock == 0){
        
       $(atc+" .loader-button__text").html(solddata);
         $(atc).attr('disabled', 'disabled');
       }
       else{
          $(atc+" .loader-button__text").html(avadata);
           $(atc).removeAttr("disabled");
       }
      
      $(dotsid).removeClass("active");
      $(data2).addClass("active");
      $(disableproduct).removeClass("active");
      $(data).addClass("active");

       $(data3).html(price);
      
    });





setInterval(function() { 
 

    if ($(".spare-discount").length > 0 ) {
  }
      else {
   var existingElement = $('.subscription-radio .discount-label');

      // Create an empty div element with the class "spare-discount"
      var newDiv = $('<div>', {
        class: 'spare-discount'
      });
      

      // Insert the empty div after the existing element
      existingElement.after(newDiv);

      }

     if ($(".discount-custom2").length > 0 ) {
  }
  else{

    try{
 data = $(".subscription-radio .discount-label").html();
 var arrayElement = data ;
// Use regular expression to extract the numeric part
var numericMatch = arrayElement.match(/\b\d+\b/);

// Check if numeric part was found
if (numericMatch) {
  // Extracted numeric value
  var extractedNumeric = parseInt(numericMatch[0], 10);
  
$(".subscription-radio .discount-label").html("Sparabo <span class='discount-custom2'>Spare "+extractedNumeric+"% extra!</span>")
} 
    }catch(e){
      
    }
  }
    if ($(".custom-text-subscription").length > 0 ) {
  }
      else 
    {
      $(".rc-selling-plans").append("<div class='custom-text-subscription'><span class='subscol1'>Flexibles Sparabo</span><span class='subscol2'>Einfach stornieren</span></div>");  
    }
   }, 500);



$(".cross-announsement").click(function(){
$(".ed-additional-announcement-bar").fadeOut();
    localStorage.setItem("hide_announcement", "true"); 
  });
 var getdata = localStorage.getItem("hide_announcement");
   if (getdata == "true"){
    $(".ed-additional-announcement-bar").hide();
   }
else{
  $(".ed-additional-announcement-bar").show();
}


$(document).on("click",".same-class-filter",function() {
$(".same-class-filter").removeClass("active");
  $(this).addClass("active");
  $("body").removeClass("multi-product-custom");
  $("body").removeClass("single-product-custom")
  var data = $(this).attr("data");
  $("body").addClass(data);
});

window.addEventListener("sc:discount.calculated", function() {
  setTimeout(() => {
    fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
      async (response) => {
        const cartContent = await response.json();
        
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: {
              cart: cartContent,
            },
          })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
          })
        );
      }
    ).catch(error => {
      console.error("Error fetching cart data with delay:", error);
    });
  }, 750);
});

document.addEventListener('DOMContentLoaded', function() {
    var event = new CustomEvent('sc:discount.calculated', {
        bubbles: true,
        cancelable: true
    });

    document.dispatchEvent(event);
});


